/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Typography, Button, Modal, Image, Segmented, Skeleton, Empty } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import * as AntDIcons from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { useDispatch } from 'react-redux';
import { reset_mastery_data } from '../../actions';
import DocumentViewer from '../../components/document-viewer/DocumentViewer';
import '../common/BraineeModule.css';

const { Text } = Typography;

export function MasterySubjects() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   //const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const [subjectList, setSubjectList] = useState([]);
   const [loading, setLoading] = useState(false);
   const [visibleContentGuide, setVisibleContentGuide] = useState(false);
   const [contentGuideURL, setContentGuideURL] = useState(null);
   const [subjectName, setSubjectName] = useState(null);

   const [questionType, setQuestionType] = useState(1);
   const [questionTypeModalVisible, setQuestionTypeModalVisible] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      localStorage.removeItem('mastery-assessment-search-keys');
      getMasterySubjects();

   }, []);

   const getMasterySubjects = () => {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/getmasterysubjects`).then((response) => {
         if (response.data) {
            const data = response.data;
            var subjects = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               subjects.push(obj);
            });

            setSubjectList(subjects);
         }
         setLoading(false);
      }, (error) => {
         setLoading(false);
         console.log(error.message);
      });
   }

   // function colorize() {
   //    var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   //    return '#' + r + g + b;
   // }

   const handleCreateMastery = () => {
      var params = { key: ``, value: '' };
      dispatch(reset_mastery_data(params));

      navigate(`/masteryassessment/create?qt=${questionType}`);
   }

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`/masteryassessmentsubject?id=${subject}&name=${subjectname}`)
   }

   const handleContentGuideClick = (subject, subjectname) => {
      var url = `${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/masterycontentguide?subject=${subject}`;

      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;

            setContentGuideURL(data);
            setSubjectName(subjectname);
            setVisibleContentGuide(true);
         }
      }, (error) => {
         console.log(error.message);
      });

   }

   const renderSubjectSkeletons = () => (
      <div className="brainee-module-skeleton-grid">
         {Array.from({ length: 6 }).map((_, index) => (
            <div className="brainee-module-card is-skeleton" key={`mastery-subject-skeleton-${index}`}>
               <Skeleton.Avatar active shape="square" className="brainee-module-card-skeleton-icon" />
               <div className="brainee-module-card-copy">
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-title" />
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-subtitle" />
               </div>
               <Skeleton.Button active size="small" shape="circle" className="brainee-module-card-skeleton-action" />
            </div>
         ))}
      </div>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li className="active">Brainee LMS</li>
                     <li><span>/</span></li>
                     <li className="active">Mastery Subjects</li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: 'Brainee LMS' },
                        { key: 'mastery-subject', node: 'Mastery Subject' },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div>
                     <span className="brainee-module-kicker">Brainee LMS</span>
                     <h1>Mastery</h1>
                     <p>Choose a subject to manage mastery assessments, content guides, and standards-based learning paths.</p>
                     <div className="brainee-module-meta">
                        <span><AntDIcons.BookOutlined /> {loading ? 'Loading subjects' : `${subjectList.length} subjects`}</span>
                        <span><AntDIcons.SnippetsOutlined /> Mastery Assessment</span>
                     </div>
                  </div>
                  {['Super Admin', 'Admin'].includes(user_role) &&
                     <div className="brainee-module-actions">
                        <Button className='brainee-module-create-btn' type="primary" size="large" shape='round' onClick={() => setQuestionTypeModalVisible(true)}>
                           <AntDIcons.PlusOutlined />Create Mastery
                        </Button>
                     </div>
                  }
               </section>

               <section className="brainee-module-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Browse</span>
                        <h2>Subject Groups</h2>
                     </div>
                     <span className="brainee-module-count">{loading ? '...' : subjectList.length}</span>
                  </div>

                  {loading
                     ? renderSubjectSkeletons()
                     : subjectList.length > 0
                        ? <div className="brainee-module-grid">
                           {subjectList.map((subject) => (
                              <button className="brainee-module-card" key={subject.value} type="button" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                 <span className="brainee-module-card-icon"><AntDIcons.BookOutlined /></span>
                                 <span className="brainee-module-card-copy">
                                    <span className="brainee-module-card-title">{subject.name}</span>
                                    <span className="brainee-module-card-subtitle">Open mastery assessments</span>
                                    <span className="brainee-module-card-badges">
                                       <Button size="small" shape="round" onClick={(event) => { event.stopPropagation(); handleContentGuideClick(subject.value, subject.name); }}>Content Guide</Button>
                                    </span>
                                 </span>
                                 <AntDIcons.RightOutlined className="brainee-module-card-arrow" />
                              </button>
                           ))}
                        </div>
                        : <div className='brainee-module-state'>
                           <Empty image="../images/brainee_mascot.png" description="No records found." />
                        </div>
                  }
               </section>
            </div>
         </div>

         <Modal
            key="modal-learning-plan"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" width="28px" style={{ minWidth: '30px', maxHeight: '100px' }} /> Content Guide for {subjectName}</div>}
            destroyOnClose={true}
            centered
            open={visibleContentGuide}
            onOk={() => setVisibleContentGuide(false)}
            okText={"Close"}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round", style: { display: 'none' } }}
            width='80%'
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={contentGuideURL}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 285px)"}
               />
            </div>
         </Modal>

         <Modal
            title="Select Questionaire Option"
            centered
            destroyOnClose={true}
            open={questionTypeModalVisible}
            onOk={() => handleCreateMastery()}
            onCancel={() => setQuestionTypeModalVisible(false)}
            cancelButtonProps={{ shape: "round" }}
            okButtonProps={{ shape: "round" }}
            width={"300px"}
         >
            <Segmented
               key={'uid'}
               value={questionType}
               block
               options={[
                  {
                     label: 'Upload',
                     value: 1,
                  },
                  {
                     label: 'Create',
                     value: 2,
                  },
               ]}
               onChange={(val) => setQuestionType(val)}
            />
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', paddingTop: '20px' }}>
               <Text strong>
                  {
                     questionType === 1
                        ?
                        'Upload a questionaire in pdf format'
                        :
                        'Manually create the questionaire'
                  }
               </Text>
            </div>
         </Modal>
      </>
   )
}

